module.exports = __webpack_public_path__ + "img/team-member-07.541a1318.jpg";